import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import AdminDietaryForm from "./AdminDietaryForm";

const AdminEditDietary = ({id, children, onChange, ...rest}) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const [form, setForm] = useState({});

    const loadData = () => {
        adminHttp
            .get('/dietaries/' + id)
            .then(res => {
                setForm({
                    'name': res.data.name,
                    'display_order': res.data.display_order,
                    'translations': res.data.translations,
                });
            });
    };

    useEffect(loadData, []);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        adminHttp
            .put('/dietaries/' + id, form)
            .then(res => {
                setError(null);
                setShow(false);
                onChange();
            }).catch((error) => {
            setError(error.response?.data);
        });
    };

    return (
        <>
            <a {...rest} onClick={handleShow}>{children}</a>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Dietary #{id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving user!"}
                        </div>
                    )}

                    <AdminDietaryForm
                        values={form}
                        errors={error?.errors}
                        onChange={f => setForm(f)} />

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default AdminEditDietary;
